import "../styles/swe.css";
import React, { useState, useEffect } from "react";
import {
  allMeetingReset,
  getUsers,
  changeSecretCode,
  secretCode,
  setMeetingOpening,
  getUsersMeetingReset,
  getMeetingOpening,
  getUser,
  createUser,
  deleteUser,
  meetingReset,
  meetings,
} from "../api"; // Import necessary API functions
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";

function AdminPage() {
  const [meetingOpening, setLMeetingOpening] = useState(0);
  const [users, setUsers] = useState([]);
  const [newSecretCode, setNewSecretCode] = useState("");
  const [currentSecretCode, setCurrentSecretCode] = useState("");
  const [attendingUsers, setAttendingUsers] = useState([]);
  const [netIDsearch, setNetIDsearch] = useState("");
  const [searchedUser, setSearchedUser] = useState(null);

  const navigate = useNavigate();
  const isDevMode = false;
  const getDevFeature = () => {
    return isDevMode ? '' : 'hidden';
  };

  useEffect(() => {
    const isAdminAuthenticated = sessionStorage.getItem("isAdminAuthenticated");
    if (!isAdminAuthenticated) {
      // If not authenticated as admin, redirect to login page
      navigate("/login");
    }
  }, [navigate]);

  useEffect(() => {
    // Fetch meeting opening number and list of users when component mounts
    //fetchMeetingOpening();
    fetchUsers();
    fetchSecretCode();
    fetchattendingUsers();
    fetchMeetingOpening();
  }, []);
  const fetchMeetingOpening = async () => {
    try {
      const response = await getMeetingOpening("admin_id");
      if (response.status === 200) {
        setLMeetingOpening(response.data.meetingOpening);
      }
    } catch (err) {
      console.error(err);
    }
  };
  const fetchUsers = async () => {
    try {
      const response = await getUsers(); // Fetch list of users
      const usersWithMeetings = response.data.map((user) => {
        return {
          ...user,
          meetingsAttended: user.meetings.length, // Assuming 'meetings' is an array of meetings attended by the user
        };
      });

      // Sort the users by the number of meetings attended in descending order
      const sortedUsers = usersWithMeetings.sort(
        (a, b) => b.meetings - a.meetings
      );
      setUsers(sortedUsers);
    } catch (error) {
      console.error("Error fetching users:", error);
    }
  };
  const fetchattendingUsers = async () => {
    try {
      const response = await getUsersMeetingReset(2);
      if (response.status === 200) {
        setAttendingUsers(response.data);
      }
    } catch (error) {
      console.log("Error fetching users:", error);
    }
  };
  const fetchSecretCode = async () => {
    try {
      const response = await secretCode("admin_id"); // Fetch current secret code
      setCurrentSecretCode(response.data);
    } catch (error) {
      console.error("Error fetching secret code:", error);
    }
  };
  const handleStartMeeting = async () => {
    try {
      const response = await allMeetingReset(1); // Set meeting opening number to 1 to start the meeting
      const response1 = await setMeetingOpening("65fcd9d5615c7d031860cb18", 1);
      const response2 = await getMeetingOpening("admin_id");
      if (response.status === 200 && response1.status === 200) {
        setLMeetingOpening(response2.data.meetingOpening);
        alert("Meeting started successfully.");
      } else {
        alert("Failed to start meeting. Please try again.");
      }
    } catch (error) {
      console.error("Error starting meeting:", error);
      alert("Failed to start meeting. Please try again.");
    }
  };
  const handleStartExtraMeeting = async () => {
    try {
      const response = await allMeetingReset(3); // Set meeting opening number to 3 to start the meeting
      const response1 = await setMeetingOpening("65fcd9d5615c7d031860cb18", 3);
      const response2 = await getMeetingOpening("admin_id");
      if (response.status === 200 && response1.status === 200) {
        setLMeetingOpening(response2.data.meetingOpening);
        alert("Meeting started successfully.");
      } else {
        alert("Failed to start meeting. Please try again.");
      }
    } catch (error) {
      console.error("Error starting meeting:", error);
      alert("Failed to start meeting. Please try again.");
    }
  };


  const handleEndMeeting = async () => {
    try {
      const response = await allMeetingReset(0);
      const response1 = await setMeetingOpening("65fcd9d5615c7d031860cb18", 0);
      const response2 = await getMeetingOpening("admin_id");
      // Set meeting opening number to 0 to end the meeting
      if (response.status === 200 && response1.status === 200) {
        setLMeetingOpening(response2.data.meetingOpening);
        alert("Meeting ended successfully.");
      } else {
        alert("Failed to end meeting. Please try again.");
      }
    } catch (error) {
      console.error("Error ending meeting:", error);
      alert("Failed to end meeting. Please try again.");
    }
  };
  const handleChangeSecretCode = async () => {
    try {
      const response = await changeSecretCode(
        "65fcd9d5615c7d031860cb18",
        newSecretCode
      );
      if (response.status === 200) {
        alert("Secret code changed successfully.");
      } else {
        alert("Failed to change secret code. Please try again.");
      }
    } catch (error) {
      console.error("Error changing secret code:", error);
      alert("Failed to change secret code. Please try again.");
    }
  };

  const handleNewSecretCodeChange = (e) => {
    setNewSecretCode(e.target.value);
  };
  const handleSearch = async () => {
    try {
      const response = await getUser(netIDsearch);
      if (response.status === 200) {
        setSearchedUser(response.data);

        // Handle the retrieved user data, such as displaying it or storing it in state
        console.log(response.data); // Example: Log the retrieved user data
      } else {
        setSearchedUser(null);
        alert("User not found.");
      }
    } catch (error) {
      console.error("Error searching for user:", error);
      alert("Error searching for user. Please try again.");
    }
  };

  const deleteSearchedUser = async () => {
    try {
      if (!searchedUser) {
        alert("No user selected to delete.");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this user?\nThis action cannot be undone!"
      );

      if (confirmDelete) {
        await deleteUser(searchedUser.netID); // Delete the searched user by netID
        setSearchedUser(null); // Reset the searchedUser state after deletion
        alert("User deleted successfully.");
        fetchUsers(); // Refresh the user list after deleting the user
      } else {
        alert("User deletion cancelled.");
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("Failed to delete user. Please try again.");
    }
  };

  const handleNetIDSearchChange = (e) => {
    setNetIDsearch(e.target.value);
  };

  const createMultipleUsers = async () => {
    try {
      // Check if test users already exist
      const existingUsersResponse = await getUsers();
      const existingUsers = existingUsersResponse.data.filter((user) =>
        user.netID.startsWith("user")
      );
      if (existingUsers.length > 0) {
        // Test users already exist, handle accordingly (e.g., display a message)
        alert("Test users already exist.");
        return;
      }

      // Create test users if they don't already exist
      for (let i = 0; i < 10; i++) {
        const fakeData = {
          firstName: `User${i + 1}`,
          lastName: `Lastname${i + 1}`,
          netID: `user${i + 1}`,
          email: `user${i + 1}@example.com`,
          password: "password123",
          major: "Computer Science", // Change as needed
          gradStatus: "Undergrad", // Change as needed
          gradYear: 2025, // Change as needed
        };
        await createUser(fakeData);
      }
      // Refresh the user list after creating users
      fetchUsers();
    } catch (error) {
      console.error("Error creating test users:", error);
      alert("Failed to create test users. Please try again.");
    }
  };

  const deleteTestUsers = async () => {
    try {
      const response = await getUsers(); // Fetch the current list of users
      const usersToDelete = response.data.filter((user) =>
        user.netID.startsWith("user")
      ); // Filter test users
      for (const user of usersToDelete) {
        await deleteUser(user.netID); // Delete each test user by netID
      }
      // Refresh the user list after deleting test users
      fetchUsers();
    } catch (error) {
      console.error("Error deleting test users:", error);
      alert("Failed to delete test users. Please try again.");
    }
  };
  const csvData = users.map(user => ({
    netID: user.netID,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    meetings: user.meetings,
    otherMeetings: user.otherMeetings,
    major: user.major,
    gradYear: user.gradYear,
    gradStatus: user.gradStatus
  }));

  return (
    <div>
      <Navbar />
      <div className="swe-backdrop justify-center gap-4 p-4">
        <div className="swe-user-card self-center items-center h-fit">
          <h2 className="swe-title mb-16 text-swe-red">Admin</h2>
          <div className="swe-box-auto items-center gap-4">
            <div className="">
              <input
                type="text"
                value={newSecretCode}
                onChange={handleNewSecretCodeChange}
                placeholder="Enter new secret code"
              />
              <button
                className="bg-green-500 text-white px-4 py-2 rounded ml-4"
                onClick={handleChangeSecretCode}
              >
                Change Secret Code
              </button>
            </div>
            <div className="">
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-4"
                onClick={handleStartMeeting}
                disabled={meetingOpening > 0}
              >
                Start General Meeting
              </button>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-4"
                onClick={handleStartExtraMeeting}
                disabled={meetingOpening > 0}
              >
                Start Other Meeting
              </button>
              <button
                className={`bg-red-500 text-white px-4 py-2 rounded ${
                  meetingOpening === 0 ? "opacity-50" : ""
                }`}
                onClick={handleEndMeeting}
                disabled={meetingOpening === 0}
              >
                End Meeting
              </button> 
            </div>
            <div className={getDevFeature()}>
              <button
                className="bg-blue-500 text-white px-4 py-2 rounded mr-4"
                onClick={createMultipleUsers}
              >
                Create Test Users
              </button>
              <button
                onClick={deleteTestUsers}
                className="bg-blue-500 text-white px-4 py-2 rounded mr-4"
              >
                Delete Test Users
              </button>
            </div>
            <div className="flex items-center mt-4">
              <input
                type="text"
                value={netIDsearch}
                onChange={handleNetIDSearchChange}
                placeholder="Enter NetID to search"
                className="bg-gray-200 px-4 py-2 rounded mr-4"
              />
              <div>
                <button
                  className="bg-green-500 text-white px-4 py-2 rounded"
                  onClick={handleSearch}
                >
                  Search
                </button>
              </div>
            </div>
            {searchedUser && (
              <div className="bg-gray-100 p-4 rounded-lg shadow-md">
                <p className="mb-2">
                  <strong>NetID:</strong> {searchedUser.netID}
                </p>
                <p className="mb-2">
                  <strong># of General Meetings:</strong> {searchedUser.meetings}
                </p>
                <p className="mb-2">
                  <strong># of Other Meetings:</strong> {searchedUser.otherMeetings}
                </p>
                <p className="mb-2">
                  <strong>Name:</strong> {searchedUser.firstName}{" "}
                  {searchedUser.lastName}
                </p>
                <p className="mb-2">
                  <strong>Email:</strong> {searchedUser.email}
                </p>
                <p className="mb-2">
                  <strong>Major:</strong> {searchedUser.major}
                </p>
                <p className="mb-2">
                  <strong>Grad Status:</strong> {searchedUser.gradStatus}
                </p>
                <p className="mb-2">
                  <strong>Grad Year:</strong> {searchedUser.gradYear}
                </p>
                <div className="swe-box-auto justify-center items-center">
                <button
                  onClick={deleteSearchedUser}
                  className="bg-red-500 text-white px-4 py-2 rounded mt-4"
                >
                  Delete Searched User
                </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="swe-user-card self-center items-center gap-4 w-fit">
          {(meetingOpening === 1 ||meetingOpening === 3)  
          && (
            <>
              <h3 className="swe-title text-swe-purplelight">
                Currently At Meeting
              </h3>
              <div className="overflow-auto">
                <table className="w-full border-collapse border border-gray-400">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border border-gray-400 px-4 py-2">
                        NetID
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        Name
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        Email
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        General Meetings Attended
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        Other Meetings Attended
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        Major
                      </th>
                      <th className="border border-gray-400 px-4 py-2">
                        Grad Year
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {attendingUsers.map((user) => (
                      <tr key={user.netID}>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.netID}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.firstName}{" "}{user.lastName}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.email}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.meetings}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.otherMeetings}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.major}
                        </td>
                        <td className="border border-gray-400 px-4 py-2">
                          {user.gradYear}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <h3 className="swe-title text-swe-purplelight">All Users</h3>
          <h3 className="swe-subtext">
            Current Secret Code: {currentSecretCode.secretPasscode}
          </h3>
          <div className="overflow-auto">
            <table className="w-full border-collapse border border-gray-400">
              <thead>
                <tr className="bg-gray-200">
                  <th className="border border-gray-400 px-4 py-2">NetID</th>
                  <th className="border border-gray-400 px-4 py-2">
                  Name
                  </th>
                  <th className="border border-gray-400 px-4 py-2">Email</th>
                  <th className="border border-gray-400 px-4 py-2">
                    General Meetings Attended
                  </th>
                  <th className="border border-gray-400 px-4 py-2">
                    Other Meetings Attended
                  </th>
                  <th className="border border-gray-400 px-4 py-2">Major</th>
                  <th className="border border-gray-400 px-4 py-2">
                    Grad Year
                  </th>
                  <th className="border border-gray-400 px-4 py-2">
                    Grad Status
                  </th>
                </tr>
              </thead>
              <tbody>
                {users.map((user) => (
                  <tr key={user.netID}>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.netID}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.firstName} {" "}{user.lastName}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.email}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.meetings}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.otherMeetings}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.major}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.gradYear}
                    </td>
                    <td className="border border-gray-400 px-4 py-2">
                      {user.gradStatus}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminPage;
